// Libraries
import React from 'react'

// Components
import Grid from '@material-ui/core/Grid'
import GlobalContainer from '../globalContainer'
import Button from './../button'
import Typography from './../typography'

// Styles
import { BlogCollectionRowContainer } from './style'

// Helpers
import formatInlineCode from '../../../utils/shortTextFormatting'
import WrapperImage from '../wrapperImage'
import ImgUtil from './../../../utils/img.utils'

type BlogCollectionRowProps = {
  headline: string
  robotImage: string
  categories: {
    name: string
    description: string
    ctaText: string
  }[]
  className?: string
}

const BlogCollectionRow = (props: BlogCollectionRowProps) => {
  return (
    <BlogCollectionRowContainer
      data-cy="BlogCollectionRow"
      className={props.className ? props.className : undefined}>
      <GlobalContainer>
        <Grid container spacing={6} className="BlogCollectionRow__Container">
          <Grid item className="BlogCollectionRow__Headline-Container" xs={12} sm={6} md={3}>
            <WrapperImage
              src={ImgUtil.getResizedImageUrl(props.robotImage, 'width=180')}
              width={180}
              height={180}
              threshold={650}
            />
            <Typography type="header2">{formatInlineCode(props.headline)}</Typography>
          </Grid>
          {props.categories.map((item: any, n: number) => (
            <Grid
              item
              className="BlogCollectionRow__Category-Container"
              xs={12}
              sm={6}
              md={3}
              key={`BlogCollectionRow__Category--${n}`}>
              <Typography type="header3" className="BlogCollectionRow__Header">
                {item.name}
              </Typography>
              <Typography type="body" className="BlogCollectionRow__Description">
                {item.description}
              </Typography>
              <Button
                type="text-link"
                theme="light"
                text={item.ctaText}
                icon={true}
                href={`https://www.uipath.com/blog/${item.name
                  .toLowerCase()
                  .replace(/ *\([^)]*\) */g, '')
                  .replace(/\s/g, '-')}`}
              />
            </Grid>
          ))}
        </Grid>
      </GlobalContainer>
    </BlogCollectionRowContainer>
  )
}

export default BlogCollectionRow
